import { useQuery } from '@apollo/client';
import { Num } from '@livecontrol/core-utils';
import type { SchedulingDefaults } from '@livecontrol/scheduler/model';
import { useEffect, useState } from 'react';
import * as Dbx from './dbx';

interface TData {
  getSchedulingDefaultsByClientId?: Dbx.Record[];
}

interface TVariables {
  clientId?: number;
}

export const useEventsDefaults = (clientId?: number): {
    defaults: SchedulingDefaults[] | undefined; loading: boolean; refetch: () => Promise<unknown>;
} => {
  const [defaults, setDefaults] = useState<SchedulingDefaults[]>();

  const { data, loading, refetch } = useQuery<TData, TVariables>(Dbx.QUERY, {
      variables: { clientId:  Num.toInteger(clientId, { positive: true }) },
      skip: !Num.toInteger(clientId, { positive: true })
  });

  useEffect(() => {
    if (!data) {
      return;
    }

    const defaults_ = data.getSchedulingDefaultsByClientId?.
    map(data_ => Dbx.normalize(data_))
    .filter((data_): data_ is SchedulingDefaults => !!data_);

    setDefaults(defaults_);
  }, [data]);

  return {
    defaults,
    loading,
    refetch
  };
};
